import React, { useContext, useState } from 'react';
import { CustomerContext } from '../CustomerContext';
import { Error } from '@app/shared';
import { useNavigate } from 'react-router-dom';
import { useAsyncEffect } from '../../../hooks/UseAsyncEffect';

export default function UpdateCustomer() {
  const navigate = useNavigate();
  const { error, setError, customerId, customerInformationService } = useContext(CustomerContext);
  const [submitting, setSubmitting] = useState(false as boolean);
  const [loading, setLoading] = useState(false as boolean);
  const [externalId, setExternalId] = useState(undefined as string);
  const [title, setTitle] = useState(undefined as string);
  const [givenName, setGivenName] = useState(undefined as string);
  const [middleName, setMiddleName] = useState(undefined as string);
  const [familyName, setFamilyName] = useState(undefined as string);
  const [suffix, setSuffix] = useState(undefined as string);
  const [dateOfBirth, setDateOfBirth] = useState(undefined as string);

  useAsyncEffect(async () => {
    try {
      setLoading(true);
      const customer = await customerInformationService.getCustomerById(customerId);

      setExternalId(customer.externalId);
      setTitle(customer.title);
      setGivenName(customer.givenName);
      setMiddleName(customer.middleName);
      setFamilyName(customer.familyName);
      setSuffix(customer.suffix);
      setDateOfBirth(customer.dateOfBirth);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError({ source: 'Get Customer', ...error });
    }
  }, [customerId]);

  const onUpdateCustomer = async (e) => {
    try {
      e.preventDefault();
      setSubmitting(true);
      await customerInformationService.updateCustomer(
        customerId,
        externalId,
        title,
        givenName,
        middleName,
        familyName,
        suffix,
        dateOfBirth
      );
      navigate(`/customers/${customerId}`);
    } catch (error) {
      setError({ source: 'Update Customer', ...error });
      setSubmitting(false);
    }
  };

  const onCancel = () => {
    navigate(`/customers/${customerId}`);
  };

  return (
    <section>
      <h1>Update Customer</h1>
      <Error error={error} setError={setError} />
      <form className="ui form" onSubmit={(e) => onUpdateCustomer(e)}>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">ExternalId</div>
            <input
              type="text"
              value={externalId || ''}
              onChange={(e) => setExternalId(e.target.value)}
              disabled={loading || submitting}
              placeholder="Enter External ID"
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Title</div>
            <input
              type="text"
              value={title || ''}
              onChange={(e) => setTitle(e.target.value)}
              disabled={loading || submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Given Name *</div>
            <input
              type="text"
              required
              value={givenName || ''}
              onChange={(e) => setGivenName(e.target.value)}
              disabled={loading || submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">MiddleName</div>
            <input
              type="text"
              value={middleName || ''}
              onChange={(e) => setMiddleName(e.target.value)}
              disabled={loading || submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Family Name *</div>
            <input
              type="text"
              required
              value={familyName || ''}
              onChange={(e) => setFamilyName(e.target.value)}
              disabled={loading || submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Suffix</div>
            <input
              type="text"
              value={suffix || ''}
              onChange={(e) => setSuffix(e.target.value)}
              disabled={loading || submitting}
            />
          </div>
        </div>

        <button className={`ui primary button ${submitting && 'loading'}`} disabled={loading} type="submit">
          Update Customer
        </button>
        <button className="ui secondary button" onClick={() => onCancel()}>
          Cancel
        </button>
      </form>
    </section>
  );
}
